import React from 'react';
import { useMusicPlayer } from '../../contexts/MusicPlayerContext';
import { X, Trash2, Music2, ListMusic } from 'lucide-react';

const FALLBACK_IMG =
  'https://distribution-pink.s3.ap-northeast-3.amazonaws.com/dev/images/none_image.jpg';

function PlaylistPanel() {
  const { playlist, currentIndex, playTrack, removeFromPlaylist, clearPlaylist, togglePlaylist } =
    useMusicPlayer();

  return (
    <div className="fixed bottom-[98px] sm:bottom-[68px] right-0 z-50 w-full sm:w-80 max-h-[70vh] sm:max-h-[520px] bg-[#1a2940] border border-white/10 sm:rounded-tl-xl rounded-t-xl shadow-2xl flex flex-col overflow-hidden">
      {/* 헤더 */}
      <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 shrink-0">
        <div className="flex items-center gap-2">
          <ListMusic size={14} className="text-slate-400" />
          <span className="text-white text-sm font-medium">
            플레이리스트{playlist.length > 0 && ` (${playlist.length}곡)`}
          </span>
        </div>
        <div className="flex items-center gap-2">
          {playlist.length > 0 && (
            <button
              onClick={clearPlaylist}
              title="전체 삭제"
              className="p-1 text-slate-500 hover:text-rose-400 transition-colors">
              <Trash2 size={14} />
            </button>
          )}
          <button
            onClick={togglePlaylist}
            className="p-1 text-slate-500 hover:text-white transition-colors">
            <X size={16} />
          </button>
        </div>
      </div>

      {/* 목록 */}
      <div className="flex-1 overflow-y-auto player-scroll">
        {playlist.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 gap-2 text-slate-500 text-sm">
            <Music2 size={28} className="opacity-30" />
            <span>플레이리스트가 비어 있습니다</span>
          </div>
        ) : (
          <ul>
            {playlist.map((track, i) => {
              const isActive = i === currentIndex;
              return (
                <li
                  key={`${track.id}-${i}`}
                  onClick={() => playTrack(i)}
                  className={`flex items-center gap-3 px-4 py-2.5 cursor-pointer group transition-colors ${
                    isActive ? 'bg-sky-500/10' : 'hover:bg-white/5'
                  }`}>
                  {/* 앨범 아트 */}
                  <div className="relative shrink-0">
                    <img
                      src={track.albumImage || FALLBACK_IMG}
                      alt=""
                      className="w-9 h-9 rounded-md object-cover"
                    />
                    {isActive && (
                      <div className="absolute inset-0 bg-sky-500/20 rounded-md flex items-center justify-center">
                        <span className="flex gap-0.5">
                          {[0, 1, 2].map((b) => (
                            <span
                              key={b}
                              className="w-0.5 bg-sky-400 rounded-full animate-bounce"
                              style={{
                                height: '10px',
                                animationDelay: `${b * 0.15}s`,
                                animationDuration: '0.8s',
                              }}
                            />
                          ))}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* 곡 정보 */}
                  <div className="flex-1 min-w-0">
                    <p
                      className={`text-sm font-medium truncate ${
                        isActive ? 'text-sky-400' : 'text-white'
                      }`}>
                      {track.nameKr}
                    </p>
                    <p className="text-slate-400 text-xs truncate">{track.artistKr}</p>
                  </div>

                  {/* 삭제 버튼 */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      removeFromPlaylist(i);
                    }}
                    title="삭제"
                    className="p-1 text-slate-600 hover:text-rose-400 opacity-0 group-hover:opacity-100 transition-colors shrink-0">
                    <X size={14} />
                  </button>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
}

export default PlaylistPanel;
